import PropTypes from 'prop-types'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import { Icon, Text, TransparentButton } from '@redriverpress/system'

// Extension of Algolia's ClearRefinements component
// https://www.algolia.com/doc/api-reference/widgets/clear-refinements/react/
function ClearRefinements({ items, refine }) {
  return (
    <TransparentButton
      onClick={() => refine(items)}
      color='blue700'
      px={3}
      py={2}
    >
      <Icon icon='sync-alt' pr={2} />
      <Text as='span' fontWeight={600}>
        Start Over
      </Text>
    </TransparentButton>
  )
}

ClearRefinements.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  refine: PropTypes.func.isRequired,
}

export default connectCurrentRefinements(ClearRefinements)
